var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.913,
    viewBox: "0 0 18 17.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "box",
    d: "M10.48,11.15a4.285,4.285,0,0,0,.77.24v9.52a2.64,2.64,0,0,1-.47-.17l-6-2.67A3,3,0,0,1,3,15.33V8.67a2.955,2.955,0,0,1,.11-.79Zm4.34-2.23L6.67,5.09l-1.89.84a2.909,2.909,0,0,0-.91.63l7.21,3.21a2.268,2.268,0,0,0,1.84,0Zm5.31-2.36a2.909,2.909,0,0,0-.91-.63l-6-2.67a2.966,2.966,0,0,0-2.44,0L8.49,4.28l8.15,3.83Zm.76,1.32L17.38,9.44v2.45a.75.75,0,1,1-1.5,0V10.1l-2.36,1.05a5.275,5.275,0,0,1-.77.24v9.52a2.64,2.64,0,0,0,.47-.17l6-2.67A3,3,0,0,0,21,15.33V8.67a2.955,2.955,0,0,0-.11-.79Z",
    transform: "translate(-3 -2.997)",
    fill: "#07357e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.a28912e5d5d7f771ddd1e646eb414134.svg";
export { ForwardRef as ReactComponent };